import script from "./chat.vue?vue&type=script&setup=true&lang=js"
export * from "./chat.vue?vue&type=script&setup=true&lang=js"

import "./chat.vue?vue&type=style&index=0&id=10d6d248&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d6d248"]])

export default __exports__